export const financialStatusTranslations = {
  PAID: 'Đã thanh toán',
  // S17: set automatically when a package order gains an instant (mua lẻ) line.
  PAID_UNBILLED_ITEMS: 'Đã TT — còn mục mua lẻ',
  UNPAID: 'Chưa thanh toán',
  PENDING: 'Đang chờ',
  SKIPPED: 'Bỏ qua',
  MAPPED_BANK_TRANSACTION: 'Đã ghép giao dịch',
};

export const userPackageStatusTranslations = {
  ACTIVE: 'Đang hoạt động',
  INACTIVE: 'Ngừng hoạt động',
  DELETED: 'Đã xóa',
  DONE: 'Đã hoàn thành',
};

export const sendingInvoiceStatusTranslations = {
  SENT: 'Đã gửi',
  PENDING: 'Chưa gửi',
  FAILED: 'Gửi thất bại',
};

export const getFinancialStatusColor = (status) => {
  switch (status) {
    case 'PAID':
      return 'success';
    case 'PAID_UNBILLED_ITEMS':
      return 'warning';
    case 'UNPAID':
      return 'error';
    case 'PENDING':
      return 'warning';
    case 'MAPPED_BANK_TRANSACTION':
      return 'info';
    default:
      return 'default';
  }
};

export const getUserPackageStatusColor = (status) => {
  switch (status) {
    case 'ACTIVE':
      return 'success';
    case 'INACTIVE':
      return 'default';
    case 'DELETED':
      return 'error';
    default:
      return 'default';
  }
};

export const getSendingInvoiceStatusColor = (status) => {
  switch (status) {
    case 'SENT':
      return 'success';
    case 'PENDING':
      return 'warning';
    case 'FAILED':
      return 'error';
    default:
      return 'default';
  }
};
